import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, DialogContent, IconButton, Typography, alpha, useTheme } from '@mui/material';
import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';

import { CustomRule } from '~/types/loyaltyContract';

import ExpandRuleDetails from './ExpandRuleDetails';

interface DetailsDialogProps {
  open: boolean;
  onClose: () => void;
  rule: CustomRule | null;
  columnVisibilityModel: GridColumnVisibilityModel;
  themeColor: string;
}

const DetailsDialog: React.FC<DetailsDialogProps> = ({ open, onClose, rule, columnVisibilityModel, themeColor }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backdropFilter: 'blur(20px)',
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          alignItems: 'center',
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          Rule Details:{' '}
          <Box component="span" sx={{ color: themeColor }}>
            {rule?.name}
          </Box>
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{
            borderRadius: 2,
            '&:hover': {
              bgcolor: alpha(theme.palette.error.main, 0.1),
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {rule && (
        <DialogContent sx={{ p: 3, overflowY: 'auto', overflowX: 'hidden' }}>
          <ExpandRuleDetails row={rule} columnVisibilityModel={columnVisibilityModel} />
        </DialogContent>
      )}
    </Dialog>
  );
};

export default DetailsDialog;
